export default "__VITE_ASSET__BcRLPxgL__"